import pathOr from 'ramda/es/pathOr';

import { Action } from 'types/Action';
import {
  WriteStoryState,
  WriteStoryPayload,
} from 'types/store/WriteStoryState';

import { writeStoryActions } from '../actions';

const DEFAULT_STATE: WriteStoryState = {};

const DEFAULT_ACTION: Action<WriteStoryPayload> = {
  type: '',
  payload: {},
};

export default (state = DEFAULT_STATE, action = DEFAULT_ACTION): any => {
  const localReducer = (): WriteStoryState => {
    return {
      ...state,
      ...action.payload,
    };
  };
  return pathOr(state, [action.type], {
    [writeStoryActions.UPDATE]: localReducer(),
    [writeStoryActions.CLEAR]: DEFAULT_STATE,
  });
};
